import { GX_MAIN_BACKGROUND, GX_TILE_LIGHT } from '@/config/colors';

export const DARK_GRADIENT_BACKGROUND =
  `linear-gradient(244deg, ${GX_TILE_LIGHT} 0%, ${GX_MAIN_BACKGROUND} 99.27%) !important` as const;
